<button mat-icon-button (click)="previous()" [attr.aria-label]="previousAriaLabel()">
  <mat-icon>arrow_left</mat-icon>
</button>
@if (isHandset()) {
  <h3 class="date-navigator-label date-navigator-label-trigger my-auto"
      [matMenuTriggerFor]="datePickerMenu"
      #datePickerTrigger="matMenuTrigger"
      [attr.aria-label]="pickerAriaLabel()"
      role="button"
      tabindex="0"
      (keydown.enter)="$event.preventDefault(); datePickerTrigger.openMenu()"
      (keydown.space)="$event.preventDefault(); datePickerTrigger.openMenu()">{{ label() }}</h3>
} @else {
  <h3 class="date-navigator-label my-auto">{{ label() }}</h3>
  <button mat-icon-button [matMenuTriggerFor]="datePickerMenu" #datePickerTrigger="matMenuTrigger" [attr.aria-label]="pickerAriaLabel()">
    <mat-icon>today</mat-icon>
  </button>
}
<mat-menu #datePickerMenu="matMenu" class="mat-menu-full-width xui-date-navigator-panel">
  <div (click)="$event.stopPropagation()">
    <mat-calendar [selected]="currentDate()" (selectedChange)="onPickerChanged($event)"></mat-calendar>
  </div>
</mat-menu>
<button mat-icon-button (click)="next()" [attr.aria-label]="nextAriaLabel()">
  <mat-icon>arrow_right</mat-icon>
</button>
